import firebase from "@firebase/app"
require("firebase/firestore")
require('firebase/auth')
require('firebase/storage')
require("firebase/functions");
require("firebase/analytics")

let config = {
  apiKey: "AIzaSyAu6IPATMOELI6Lo4BULVIdj8SKrVDYYaM",
  authDomain: "racing-automotors.firebaseapp.com",
  projectId: "racing-automotors",
  storageBucket: "racing-automotors.appspot.com",
  messagingSenderId: "529997210115",
  appId: "1:529997210115:web:eac6ecf677d179f2616436",
  measurementId: "G-MGS8C2R6ZV"
}

firebase.initializeApp(config)
firebase.analytics()

const db = firebase.firestore()
const _firestore = firebase.firestore
const auth = firebase.auth()
const functions = firebase.functions()
const _auth = firebase.auth
const storage = firebase.storage()
const ColeccionLanding = db.collection('Landing').doc('Contenido')
const ColeccionLandingImagenes = db.collection('Landing').doc('Imágenes')
const Colección_blog = db.collection('Landing').doc('Contenido').collection('Blog')
const Colección_etiquetas = db.collection('Landing').doc('Contenido').collection('Etiquetas')


const enviar_correo_electronico = functions.httpsCallable('correo_electronico-enviar')

export {
  db,
  functions,
  auth,
  _auth,
  storage,
  firebase,
  ColeccionLanding,
  _firestore,
  ColeccionLandingImagenes,
  enviar_correo_electronico,
  Colección_blog,
  Colección_etiquetas,
}